<div class="login-page" authTheme>
  <div class="login-container">
    <!-- Logo and Header -->
    <div class="text-center mb-4">
      <img [src]="logo" alt="ADN Logo" class="login-logo" />
      <p class="text-body-secondary small mb-0">All of American Agriculture Connected</p>
    </div>
    <h2 class="h5 fw-semibold mb-4">Sign in to get started</h2>

    <!-- Invitation Info Alert -->
    <div *ngIf="pendingInvitationMessage" class="alert alert-info" role="alert">
      <i class="bi bi-envelope-fill me-2"></i>
      {{ pendingInvitationMessage }}
    </div>

    <!-- Error Alert -->
    <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
      <i class="bi bi-exclamation-triangle me-2"></i>
      {{ errorMessage }}
    </div>

    <!-- Email Verification Required -->
    <div *ngIf="showResendVerification && !verificationSent" class="alert alert-warning" role="alert">
      <i class="bi bi-envelope-exclamation me-2"></i>
      <span>Your email address hasn't been verified yet.</span>
      <button
        type="button"
        class="btn btn-warning btn-sm ms-2"
        (click)="resendVerificationEmail()"
        [disabled]="sendingVerification"
      >
        <span *ngIf="!sendingVerification">Resend Verification Email</span>
        <span *ngIf="sendingVerification">
          <span class="spinner-border spinner-border-sm me-1" role="status"></span>
          Sending...
        </span>
      </button>
    </div>

    <!-- Verification Email Sent Success -->
    <div *ngIf="verificationSent" class="alert alert-success" role="alert">
      <i class="bi bi-check-circle me-2"></i>
      Verification email sent! Please check your inbox and click the verification link, then try signing in again.
    </div>

    <!-- Login Form -->
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <!-- Email Input -->
      <app-form-input
        label="Email Address"
        type="email"
        placeholder="you@example.com"
        formControlName="email"
        [required]="true"
        [errorMessage]="hasError('email') ? getErrorMessage('email') : ''"
      ></app-form-input>

      <!-- Password Input -->
      <app-form-password
        label="Password"
        placeholder="Enter your password"
        formControlName="password"
        [showForgotPassword]="true"
        [required]="true"
        [errorMessage]="hasError('password') ? getErrorMessage('password') : ''"
      ></app-form-password>

      <!-- Submit Button -->
      <app-form-button
        label="Sign In"
        type="submit"
        variant="primary"
        size="lg"
        [fullWidth]="true"
        [loading]="loading"
        [disabled]="loginForm.invalid"
        class="d-block mt-4 w-100"
      ></app-form-button>
    </form>

    <div class="auth-divider">
      <span>or</span>
    </div>

    <div class="vstack gap-3">
      <div class="card">
          <button class="btn card-body sign-in-option"
              (click)="signInWithPhone()">
              <i class="bi bi-phone"></i><span>Continue with text</span>
          </button>
      </div>
      <div class="card">
          <button class="btn card-body sign-in-option"
              (click)="signInWithEmail()">
              <i class="bi bi-envelope-fill"></i><span>Continue with email</span>
          </button>
      </div>
  </div>


    <!-- Sign Up Link -->
    <div class="text-center mt-4">
      <p class="text-muted">
        Don't have an account?
        <a [routerLink]="['/signup']" [queryParams]="invitationId ? { invitationId: invitationId } : {}" class="text-decoration-none fw-medium">Sign Up</a>
      </p>
    </div>

    <!-- Legal footer. `noreferrer` in addition to `noopener` so the
         outbound click doesn't leak the current ADN URL (which can
         include profile/org context in the path) to the external policy
         host via the Referer header. -->
    <p class="text-center text-muted small mt-4 mb-0">
      By continuing you agree to the
      <a [href]="legalUrls.privacyPolicy" target="_blank" rel="noopener noreferrer" class="text-decoration-none">Privacy Policy</a>
      and
      <a [href]="legalUrls.termsOfUse" target="_blank" rel="noopener noreferrer" class="text-decoration-none">Terms of Use</a>.
    </p>
  </div>
</div>
